export default __webpack_public_path__ + "static/media/MainUnit-Blue-24x24.8b58c4f8.svg";